import React from "react";
import { GroupWrapper } from "../HOC";
import { TiWeatherSunny } from "react-icons/ti";
import { AiFillCloud } from "react-icons/ai";
import Image01 from "../assets/svg/weather.svg";

const Weather = () => {
  const Weather = [
    { time: "12AM", deg: "50°C" },
    { time: "4PM", deg: "12°C" },
    { time: "5PM", deg: "85°C", active: true },
    { time: "8PM", deg: "29°C" },
    { time: "9PM", deg: "30°C" },
    { time: "8PM", deg: "29°C" },
    { time: "9PM", deg: "30°C" },
    { time: "8PM", deg: "29°C" },
  ];

  const news = [1, 2, 3, 4];
  return (
    <GroupWrapper>
      <div className="w-[52%] pb-10">
        <div>
          <p className="text-primary text-lg font-bold mb-7">Weather Alerts</p>
          <div className="flex items-center justify-between">
            {Weather.map((item, i) => (
              <div
                key={i}
                className={`border-2 border-[#f0f9ff] rounded-full p-3 flex flex-col items-center justify-center ${
                  item.active && "border-none bg-primary"
                }`}
              >
                <p
                  className={`text-xs font-semibold text-[#000] pb-3 ${
                    item.active && "!text-[#fff]"
                  }`}
                >
                  {item.time}
                </p>
                <div
                  className={`bg-[#f0f9ff] p-2 rounded-full text-primary ${
                    item.active && "!text-[#fff] !bg-[#1295f3]"
                  }`}
                >
                  {!item.active ? (
                    <TiWeatherSunny className="text-2xl" />
                  ) : (
                    <AiFillCloud className="text-2xl text-white" />
                  )}
                </div>
                <p
                  className={`text-[#b9b9b9] text-sm font-semibold pt-3 ${
                    item.active && "!text-[#fff]"
                  }`}
                >
                  {item.deg}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-7">
          <p className="text-primary text-lg font-bold mb-7">
            Local News & Headlines
          </p>
          {news.map((item) => (
            <div className="border-2 p-2 rounded-lg mb-5" key={item}>
              <img src={Image01} alt="" className="w-full object-cover mb-3" />
              <p className="text-sm font-bold mb-3">
                What to watch in Tuesday's primaries in California, Iowa, and
                more
              </p>
              <p className="text-xs font-medium h-[110px] overflow-scroll scrollbar-hide">
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                diam nonumy eirmod tempor invidunt ut labore et dolore magna
                aliquyam erat, sed diam voluptua. At vero eos et accusam et
                justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea
                takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum
                dolor sit amet, consetetur sadipscing elitr, sed diam nonumy
                eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
                sed diam voluptua. At vero eos et accusam et justo duo dolores
                et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus
                est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet,
                consetetur sadipscing elitr, sed diam nonumy eirmod tempor
                invidunt ut labore et dolore magna aliquyam erat, sed diam
                voluptua. At vero eos et accusam et justo duo dolores et ea
                rebum. Stet clita kasd gubergren, no sea takimata sanctus est
                Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet,
                consetetur sadipscing elitr, sed diam nonumy eirmod tempor
                invidunt ut labore et dolore magna aliquyam erat, sed diam
                voluptua. At vero eos et accusam et justo duo
              </p>
            </div>
          ))}
        </div>
      </div>
    </GroupWrapper>
  );
};

export default Weather;
